import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import SideBar from "../components/sidebar/sidebar";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  STUDENT_ROLE,
  STUENT_JOURNEY_URL,
  TEACHER_JOURNEY_URL,
  studentRouteConfig,
} from "../constants";
import "./StudentLayout.css";
import SessionReviewsAlert from "../components/session-reviews-alert";
import useWebSocket from "../helper/use-web-socket";
import TeacherMeetingAlert from "../components/sessions-alert";
import CommonHeader from "../components/HeaderCommon";

const StudentLayout = ({ children }) => {
  const currentUser = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const { isConnected } = useWebSocket();

   useEffect(() => {
      // console.log(`WebSocket ${isConnected ? "connected" : "disconnected"}`);
    }, [isConnected, currentUser]);

  useEffect(() => {
    if (currentUser === null) {
      navigate("/");
    } else if (currentUser?.role && currentUser?.role !== STUDENT_ROLE) {
      navigate(TEACHER_JOURNEY_URL);
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarVisible(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="student-layout">
      {isSidebarVisible && <SideBar routeConfig={studentRouteConfig} />}
      <div className="content-wrapper">
        <CommonHeader/>
        <SessionReviewsAlert />
        <TeacherMeetingAlert />
        <div className="content-container">
          <main>
            <div className="main_standard" style={{ minHeight: "90vh" }}>
              {children}
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default StudentLayout;
